// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-wrapper {
    overflow-x: auto;
    overflow-y: visible;
    border: 1px solid lightgrey;
    border-top: none;
    border-left-width: 0.225rem;
    padding-top: 2rem;
    position: relative;
}

.main-wrapper::-webkit-scrollbar {
    height: 5px;
  }
  
  /* Track */
  .main-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1; 
  }
   
  /* Handle */
  .main-wrapper::-webkit-scrollbar-thumb {
    background: #888; 
    border-radius: 10px;
  }
  
  /* Handle on hover */
  .main-wrapper::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }

.main-wrapper:before {
    content: '';
    position: absolute;
    top: 2rem;
    height: 1px;
    left: 0;
    right: 0;
    background-color: lightgray;
}

.timeline-container {
    height: 10rem;
    position: relative;
    transition: all 1s ease;
}
.timeline-container .time-contents {
    display: flex;
    position: absolute;
    top: 2rem;
    left: 20rem;
}


.time-contents p {
    display: inline-block;
    white-space: nowrap;
    color: white;
    background-color: darkslategrey;
    padding: 0.125rem 0.25rem;
    border-right: 2px solid white;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    max-width: 110px;
    width: 100%;
    min-width: 110px;
}

.audio-spectrum {
    display: flex;
    position: absolute;
    bottom: 2rem;
    left: 20rem;
    height: 200px;
    background-color: darkgray;
}

.timeline-container:before {
    content: '';
    position: absolute;
    top: 5rem;
    height: 1px;
    left: 0;
    right: 0;
    background-color: lightgray;
}

.time-labels {
    display: flex;
    position: absolute;
    top: -1.5rem;
    left: 20rem;
}
.time-labels label {
    width: 15rem;
    border-right: 1px solid lightgray;
    padding-left: 1rem;
    border-bottom: 1px solid lightgray;
    position: relative;
}
.time-labels label:before {
    position: absolute;
    content: '';
    left: 0;
    right: 0;
    top: 6.5rem;
    height: 1px;
    background-color: lightgray;
}

.time-labels label:last-child {
    border-right: none;
}


.indicator-handler {
    position: absolute;
    top: -2rem;
    bottom: 1rem;
    left: 20rem;
    z-index: 4;
}


.indicator {
    position: relative;
    width: 2px;
    cursor: pointer;
    min-height: 11rem;
    background-color: darkblue;
}
.indicator:before {
    position: absolute;
    content: '';
    width: 1rem;
    height: 1rem;
    top: 0;
    left: -0.325rem;
    border-radius: 100%;
    background-color: darkblue;
}

.icon-content {
    background-color: darkslategrey;
    height: 2rem;
    width:3rem;
    left: 3rem;
    top: 2rem;
    position: absolute;
}

.icon-music {
    position: absolute;
    left: 3rem;
    bottom: 1rem;
}

.timeline-timebox {
    border: 1px solid lightgray;
    border-radius: 4px;
    padding: 0.5rem 1rem;
}

.timeline-button {
    color: darkslategrey;
    font-weight: bold;
    cursor: pointer;
}
.timeline-button.disabled {
    color: darkgray;
}

.audio-spectrum-wave {
    position: relative;
    /* width: 100%; */
    display: flex;
    /* position: absolute; */
    top: 4rem;
    left: 9rem;
    height: 50px;
}`, "",{"version":3,"sources":["webpack://./src/Magor/Recording/Timeline.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;EACb;;EAEA,UAAU;EACV;IACE,mBAAmB;EACrB;;EAEA,WAAW;EACX;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,oBAAoB;EACpB;IACE,gBAAgB;EAClB;;AAEF;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,OAAO;IACP,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;;AAGA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;IAC/B,yBAAyB;IACzB,6BAA6B;IAC7B,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,OAAO;IACP,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;AACA;IACI,YAAY;IACZ,iCAAiC;IACjC,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,WAAW;IACX,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,UAAU;AACd;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,MAAM;IACN,eAAe;IACf,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,YAAY;IACZ,UAAU;IACV,UAAU;IACV,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,wBAAwB;IACxB,SAAS;IACT,UAAU;IACV,YAAY;AAChB","sourcesContent":[".main-wrapper {\n    overflow-x: auto;\n    overflow-y: visible;\n    border: 1px solid lightgrey;\n    border-top: none;\n    border-left-width: 0.225rem;\n    padding-top: 2rem;\n    position: relative;\n}\n\n.main-wrapper::-webkit-scrollbar {\n    height: 5px;\n  }\n  \n  /* Track */\n  .main-wrapper::-webkit-scrollbar-track {\n    background: #f1f1f1; \n  }\n   \n  /* Handle */\n  .main-wrapper::-webkit-scrollbar-thumb {\n    background: #888; \n    border-radius: 10px;\n  }\n  \n  /* Handle on hover */\n  .main-wrapper::-webkit-scrollbar-thumb:hover {\n    background: #555; \n  }\n\n.main-wrapper:before {\n    content: '';\n    position: absolute;\n    top: 2rem;\n    height: 1px;\n    left: 0;\n    right: 0;\n    background-color: lightgray;\n}\n\n.timeline-container {\n    height: 10rem;\n    position: relative;\n    transition: all 1s ease;\n}\n.timeline-container .time-contents {\n    display: flex;\n    position: absolute;\n    top: 2rem;\n    left: 20rem;\n}\n\n\n.time-contents p {\n    display: inline-block;\n    white-space: nowrap;\n    color: white;\n    background-color: darkslategrey;\n    padding: 0.125rem 0.25rem;\n    border-right: 2px solid white;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n    max-width: 110px;\n    width: 100%;\n    min-width: 110px;\n}\n\n.audio-spectrum {\n    display: flex;\n    position: absolute;\n    bottom: 2rem;\n    left: 20rem;\n    height: 200px;\n    background-color: darkgray;\n}\n\n.timeline-container:before {\n    content: '';\n    position: absolute;\n    top: 5rem;\n    height: 1px;\n    left: 0;\n    right: 0;\n    background-color: lightgray;\n}\n\n.time-labels {\n    display: flex;\n    position: absolute;\n    top: -1.5rem;\n    left: 20rem;\n}\n.time-labels label {\n    width: 15rem;\n    border-right: 1px solid lightgray;\n    padding-left: 1rem;\n    border-bottom: 1px solid lightgray;\n    position: relative;\n}\n.time-labels label:before {\n    position: absolute;\n    content: '';\n    left: 0;\n    right: 0;\n    top: 6.5rem;\n    height: 1px;\n    background-color: lightgray;\n}\n\n.time-labels label:last-child {\n    border-right: none;\n}\n\n\n.indicator-handler {\n    position: absolute;\n    top: -2rem;\n    bottom: 1rem;\n    left: 20rem;\n    z-index: 4;\n}\n\n\n.indicator {\n    position: relative;\n    width: 2px;\n    cursor: pointer;\n    min-height: 11rem;\n    background-color: darkblue;\n}\n.indicator:before {\n    position: absolute;\n    content: '';\n    width: 1rem;\n    height: 1rem;\n    top: 0;\n    left: -0.325rem;\n    border-radius: 100%;\n    background-color: darkblue;\n}\n\n.icon-content {\n    background-color: darkslategrey;\n    height: 2rem;\n    width:3rem;\n    left: 3rem;\n    top: 2rem;\n    position: absolute;\n}\n\n.icon-music {\n    position: absolute;\n    left: 3rem;\n    bottom: 1rem;\n}\n\n.timeline-timebox {\n    border: 1px solid lightgray;\n    border-radius: 4px;\n    padding: 0.5rem 1rem;\n}\n\n.timeline-button {\n    color: darkslategrey;\n    font-weight: bold;\n    cursor: pointer;\n}\n.timeline-button.disabled {\n    color: darkgray;\n}\n\n.audio-spectrum-wave {\n    position: relative;\n    /* width: 100%; */\n    display: flex;\n    /* position: absolute; */\n    top: 4rem;\n    left: 9rem;\n    height: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
